import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { QuizV2 } from '../model/current-quiz.model';
import { EditQuestion } from '../model/edit-question.model';
import { EditQuiz } from '../model/edit-quiz.model';

@Injectable({
  providedIn: 'root'
})
export class EditQuestionService {

  constructor(private http: HttpClient) { }

  saveQuestionChanges(editQuizModel: QuizV2): Observable<any>{
    return this.http.post(environment.BACKEND_HOST + environment.BACKEND_QUIZ_ENDPOINT + "/saveEditQuiz", editQuizModel);
  }

}
